export default __webpack_public_path__ + "static/fantastec-swap-1420d2bc91802ca40a49dc6d7488ebc1.png";